export default __webpack_public_path__ + "static/img2-b45341b4e9b7fe5644413691a6e86924.jpg";